var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section-view',{staticClass:"view",attrs:{"title":_vm.title,"tips":_vm.tips}},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.$emit('selected', item)}}},[_c('img',{attrs:{"src":item.image_url_small}}),_vm._v(_vm._s(item.item_dict_name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }